import { render, staticRenderFns } from "./AddFmsFollowUpDialog.vue?vue&type=template&id=0b76962a&scoped=true"
import script from "./AddFmsFollowUpDialog.vue?vue&type=script&lang=js"
export * from "./AddFmsFollowUpDialog.vue?vue&type=script&lang=js"
import style0 from "./AddFmsFollowUpDialog.vue?vue&type=style&index=0&id=0b76962a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76962a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b76962a')) {
      api.createRecord('0b76962a', component.options)
    } else {
      api.reload('0b76962a', component.options)
    }
    module.hot.accept("./AddFmsFollowUpDialog.vue?vue&type=template&id=0b76962a&scoped=true", function () {
      api.rerender('0b76962a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/AddFmsFollowUpDialog.vue"
export default component.exports